export default __webpack_public_path__ + "static/slide01-a19fe89c2a804e5b7c86be307f7e9eb9.png";